<template lang="pug">
    .settings-media-vault
        settings-page-head
        .settings-media-vault__wrapper
            .account-management__wrapper-section
                .settings-form-upload-media.settings-input-wrapper-mt
                    span.settings-input-block-name Upload Media
                    media-vault-upload-control(v-model="uploadFiles" ref="uploadControl")

                .settings-form-actions
                    settings-form-button(title="Add to Vault" :disabled="uploadFilesIds.length == 0" @click="addToVault")

            .settings-media-vault__vault-view.account-management__wrapper-section
                media-vault-view(mode="edit" ref="mediaVaultView")
</template>

<script>
import MediaVaultService from '../services/media-vault-service'

export default {
    name: 'settings-media-vault-page',

    data() {
        return {
            uploadFiles: [],
        }
    },

    computed: {
        uploadFilesIds() {
            return this.uploadFiles.map(f => f.id)
        },
    },
    
    methods: {
        addToVault() {
            MediaVaultService.assign(this.uploadFilesIds, {
                albumId: this.$refs.mediaVaultView.getSelectedAlbumId(),
            }).then((r) => {
                this.$refs.mediaVaultView.loadFiles()
                r.data.forEach(f => this.$refs.uploadControl.removeFile(f))
            })
        },
    },
}
</script>
